import type { FieldPermissionChecker } from '../entity-edit/field-permission-checker';

const AUDIT_LOG_PERMISSIONS = ['audit:read', 'dashboard:audit:read'] as const;

type AuditLogPermissionChecker = Pick<FieldPermissionChecker, 'hasPermission'> | null | undefined;

export function hasAuditLogAccess(permissionChecker: AuditLogPermissionChecker): boolean {
  if (!permissionChecker) {
    return true;
  }

  return AUDIT_LOG_PERMISSIONS.some(permission => permissionChecker.hasPermission(permission));
}
